import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ImageUpload from "src/Components/GlobalComponents/ImageUplaod";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import httpRequest from "src/helpers/httpRequest";
import { IHomePageInterface } from "src/types/GlobalInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
interface IProps {
  data: any;
  setData: React.Dispatch<React.SetStateAction<IHomePageInterface | null>>;
}

const DoctorBannerSection: React.FC<IProps> = ({
  data,
  setData,
}) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const hasWriteAccess = canWrite(userDetails, "platformManagement", false);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [doctorBanner, setDoctorBanner] = useState<File | null | string>(
    null
  );
  const [doctorBanner2, setDoctorBanner2] = useState<File | null | string>(
    null
  );

  const handleSubmit = async () => {
    if (!hasWriteAccess) {
      return;
    }

    if (!doctorBanner || !doctorBanner2) {
      toast.error("Please upload both banners");
      return;
    }

    let formData = new FormData();
    formData.append("doctorBannerOne", doctorBanner);
    formData.append("doctorBannerTwo", doctorBanner2);

    setIsLoader(true);

    let { res, err } = await httpRequest({
      path: "/website-manage/section-seven",
      method: "put",
      params: formData,
      header : {
        "Content-Type": "multipart/form-data",
      },
    });

    if (res) {
      toast.success("Doctor banner updated successfully");
    } else {
      toast.error(err);
    }
    setIsLoader(false);
  };

  useEffect(() => {
    if (data) {
      setDoctorBanner(data?.doctorBannerOne);
      setDoctorBanner2(data?.doctorBannerTwo);
    }
  }, [data]);


  return (
    <div className="section__2">
      <h1 className="font-Poppins-SemiBold font-size-25px mb-2 theme-color-green">
        Section 07
      </h1>
      <div className="products-tabs-content">
        <h3 className="font-size-18px text-[#2F2F31] mb-3 font-Poppins-Regular">
          Doctor Banner
        </h3>
        <div className="grid grid-cols-2 gap-5 gap-x-10">
          <div className="w-full">
            <ImageUpload
              newUi={true}
              image={doctorBanner}
              onImageChange={setDoctorBanner}
              extraClasses={"w-full min-h-[380px]"}
              labelId={`doctor-banner-one`}
              disabled={!hasWriteAccess}
            />
          </div>
          <div className="w-full">
            <ImageUpload
              newUi={true}
              image={doctorBanner2}
              onImageChange={setDoctorBanner2}
              extraClasses={"w-full min-h-[380px]"}
              labelId={`doctor-banner-two`}
              disabled={!hasWriteAccess}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-end mt-3">
        <PrimaryBtn
          loader={isLoader}
          ButtonText="Save"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={() => {
            if (!hasWriteAccess) {
              return;
            }
            handleSubmit();
          }}
          id="doctor-banner-save"
          disabled={!hasWriteAccess}
          btnExtralClasses={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
        />
      </div>
    </div>
  );
};

export default DoctorBannerSection;
